var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationCircle = function SvgLocationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 163,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#location-circle_svg__a)",
    d: "M95 35.252c18.107 0 32.748 14.673 32.748 32.748S113.075 100.748 95 100.748 62.252 86.075 62.252 68 76.926 35.252 95 35.252M163.802 68c0 37.949-30.853 68.802-68.802 68.802S26.198 105.949 26.198 68 57.084-.802 95-.802V-27C42.636-27 0 15.636 0 68s42.636 95 95 95 95-42.636 95-95z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "location-circle_svg__a",
    x1: 0,
    x2: 190,
    y1: -27,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgLocationCircle;